import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientLoggerService } from './client-logger.service';
import { ServerLoggerService } from './server-logger.service';
import { BufferLoggerService } from './buffer-logger.service';
import { LoggingService } from './logging.service';
import { LogConfigService } from './logconfig.service';

@NgModule({
  imports: [CommonModule],
  declarations: []
})
export class LogModule {
  static forRoot(): ModuleWithProviders<LogModuleForRoot> {
    return {
      ngModule: LogModuleForRoot
      // we had to define a separate module rather than inlining the providers here,
      // because NgbModule.forRoot() does not make its providers accessible by means other than an import,
      // which can not be specified when using the ModuleWithProviders syntax ...
    };
  }
}

@NgModule({
  imports: [LogModule],
  exports: [LogModule],
  providers: [LogConfigService, ClientLoggerService, ServerLoggerService, BufferLoggerService, LoggingService]
})
export class LogModuleForRoot {}
